module.exports = __webpack_public_path__ + "img/Yogurt-Nan-600x395.9d3097f0.jpg";